import { render, staticRenderFns } from "./PaymentInfoDialog.vue?vue&type=template&id=4ad572fd&scoped=true&"
import script from "./PaymentInfoDialog.vue?vue&type=script&lang=js&"
export * from "./PaymentInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad572fd",
  null
  
)

export default component.exports